import { getDefaultHomePage } from "./checkPermission";

const POST_LOGIN_REDIRECT_KEY = "eternalPostLoginRedirect";

/**
 * 登入前儲存使用者原本想造訪的路徑（含 query），供登入／自動登入後導回。
 */
export function savePostLoginRedirect(pathname, search = "") {
  if (!pathname || pathname === "/") return;
  const destination = `${pathname}${search || ""}`;
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, destination);
  } catch(err) {
    console.log("Error saving post login redirect", err);
    // sessionStorage 不可用時略過
  }
}

/**
 * 讀取並清除已儲存的登入後導向路徑。
 */
export function consumePostLoginRedirect() {
  try {
    const destination = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (destination) {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    }
    return destination || null;
  } catch(err) {
    console.log("Error consuming post login redirect", err);
    return null;
  }
}

/**
 * 登入成功後應導向的路徑：優先使用登入前儲存的深連結，否則回預設首頁。
 */
export function resolvePostLoginDestination(permissions) {
  const saved = consumePostLoginRedirect();
  if (saved && saved !== "/") {
    return saved;
  }
  return getDefaultHomePage(permissions);
}
